export enum AuditReportStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
  'In Progress' = 'IN_PROGRESS',
  Queued = 'QUEUED',

  // UI Only
  All = 'ALL',
}
